import _util from "./util";
var exports = {};
var util = _util;
exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}

export default exports;